import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "environments/environment";

@Component({
	selector: "sdp-download",
	templateUrl: "./download-redirect.component.html"
})
export class DownloadRedirectComponent implements OnInit {

	public autoRedirect = false;
	public redirectTime = 5;
	public readonly downloadIcon = { type: "material", name: "file_download", cssClass: "sdp-download-title-icon" };

	constructor(
		private route: ActivatedRoute
	) { }

	public ngOnInit() {
		this.route.queryParams.subscribe((params: Params) => {
			const autoRedirect: string = params["autoRedirect"];
			if (autoRedirect === "true") {
				this.autoRedirect = true;
				// tslint:disable-next-line:ban setTimeout
				setTimeout(() => {
					this.countDown();
				}, 1000);
			}
		});
	}

	public get downloadLink() {
		return environment.DOWNLOAD_SITE;
	}

	private countDown() {
		this.redirectTime--;
		if (this.redirectTime > 0) {
			// tslint:disable-next-line:ban setTimeout
			setTimeout(() => {
				this.countDown();
			}, 1000);
		} else {
			window.location.href = this.downloadLink;
		}
	}

}
